import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { typedFetch } from '../../typedFetch';
import './Login.scss';
const setupGoogleSSO = (appendToErrorLog) => {
    const handleCredentialResponse = ({ credential }) => {
        typedFetch('login', { body: { credential } }, 'no-auth')
            .then((result) => {
            if (!result.success) {
                appendToErrorLog(result.reason);
                return;
            }
            // The email below is stored ONLY for autocomplete when submitting a ticket, and never for anything else.
            // All authentication is done via the token, in typedFetch.
            localStorage.setItem('email', result.email);
            window.location.href = '/';
        })
            .catch((error) => {
            appendToErrorLog(String(error['message']));
        });
    };
    Object.assign(window, { handleCredentialResponse });
    const gId = document.querySelector('#g_id_onload');
    gId.dataset['client_id'] = process.env['GOOGLE_OAUTH_WEB_CLIENT_ID'];
    gId.dataset['callback'] = 'handleCredentialResponse';
    document.head.appendChild(document.createElement('script')).src = 'https://accounts.google.com/gsi/client';
};
export const Login = ({ appendToErrorLog }) => {
    const [needToLogin, setNeedToLogin] = useState(null);
    useEffect(() => {
        if (needToLogin) {
            setupGoogleSSO(appendToErrorLog);
        }
    }, [needToLogin, appendToErrorLog]);
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setNeedToLogin(true);
            return;
        }
        typedFetch('validate-token')
            .then((result) => {
            if (result.success) {
                window.location.href = '/';
            }
            else {
                localStorage.removeItem('token');
                setNeedToLogin(true);
            }
        })
            .catch((error) => {
            appendToErrorLog(`Unexpected error while validating token: ${String(error['message'])}`);
        });
    }, [appendToErrorLog]);
    return (_jsxs("main", { className: "login", children: [_jsx("h1", { children: "Login" }), needToLogin ? (_jsxs(_Fragment, { children: [_jsx("div", { id: "g_id_onload", "data-use_fedcm_for_prompt": "true" }), _jsx("div", { className: "g_id_signin", "data-type": "standard" })] })) : (_jsx("p", { children: "Loading..." }))] }));
};
